import { Images } from "../../Assets/Index";
import { ExtractDate, ExtractTime, getLocalStorageItem } from "../../Utils";
import { Image, Table } from "antd";
import { IoCaretBack } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { useCommmonStore } from "../../Store/CommonReducer";
import { getFundReq, getWithdrawalReq } from "./WalletApi";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import ApiService from "../../ApiServices/Axios";
const ShowWallet_fundHistory = () => {
  const [walletData, setWalletData] = useState([]);
  const [fundData, setFundData] = useState([]);
  const location = useLocation();
  const type = location?.state?.type;
  const navigate = useNavigate();
  const { profileDetail } = useCommmonStore();

  const getWalletHistory = () => {
    getWithdrawalReq()
      .then((res) => {
        if (res.status) {
          setWalletData(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const getFundHistory = () => {
    getFundReq()
      .then((res) => {
        if (res.status) {
          setFundData(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    type === "withdrawHistory" ? getWalletHistory() : getFundHistory();
  }, [type]);


  const columnsWallet = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          ₹{data}
        </p>
      ),
    },
    {
      title: "Acc.Holder Name",
      dataIndex: "bank_detail",
      key: "bank_detail",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data?.ac_holder_name}
        </p>
      ),
    },

    {
      title: "Bank",
      dataIndex: "bank_detail",
      key: "bank_detail",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data?.bank}
        </p>
      ),
    },

    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {ExtractDate(data)}.{ExtractTime(data)}
        </p>
      ),
    },
  ];
  const columnsFund = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          ₹{data}
        </p>
      ),
    },

    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: " font-dmsans text-sm",
    //   render: (data) => (
    //     <Image
    //       className="text-xs font-dmsans items-center flex justify-center "
    //       src={`${ApiService}${data}`}
    //       height={50}
    //       width={50}
    //     />
    //   ),
    // },
    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {ExtractDate(data)}.{ExtractTime(data)}
        </p>
      ),
    },
  ];
  return (
    <>
      <div className="flex justify-center  items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/wallet")}
              />
              <p className="text-xl font-normal custome">
                {type === "withdrawHistory"
                  ? "Withdraw Request History"
                  : "Fund Request History"}
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="overflow-y-scroll h-[100vh]">
            {" "}
            <div>
              <div className="m-4 bg-black ">
                {type === "withdrawHistory" ? (
                  <div className="px-4 w-full rounded-lg h-screen bg-black">
                    <AnimatePresence>
                      <Table
                        size="small"
                        rowHoverable={false}
                        columns={columnsWallet}
                        // loading={isLoading}
                        dataSource={walletData}
                        className="w-screen sm:w-screen"
                        // scroll={{
                        //   y: 240,
                        // }}
                        pagination={false}
                      />
                    </AnimatePresence>
                  </div>
                ) : (
                  <div className="px-4 w-full rounded-lg h-screen bg-black">
                    <AnimatePresence>
                      <Table
                        size="small"
                        rowHoverable={false}
                        columns={columnsFund}
                        // loading={isLoading}
                        dataSource={fundData}
                        className="w-screen sm:w-screen"
                        // scroll={{
                        //   y: 240,
                        // }}
                        pagination={false}
                      />
                    </AnimatePresence>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowWallet_fundHistory;
